(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  /**
   * Marks the heading the reader is currently under in both copies of the
   * contents — the 1728 card and the 390 accordion are the same list rendered
   * twice, one of which is always display:none.
   *
   * Position is measured off the headings rather than watched with an
   * IntersectionObserver: between two headings none of them is on screen, and a
   * plain "last heading above the line" read gives the right answer everywhere,
   * including at the very top and bottom of the article.
   */
  function initArticle() {
    document.querySelectorAll('[data-article]').forEach(function (root) {
      if (root.dataset.articleReady === 'true') return;
      root.dataset.articleReady = 'true';

      var body = root.querySelector('[data-article-body]');
      var links = Array.prototype.slice.call(root.querySelectorAll('[data-toc-link]'));
      if (!body || !links.length) return;

      /* Every level, in document order — the same set of headings the Liquid
         above put ids on, and in the same order as the links beside them. */
      var headings = Array.prototype.slice.call(
        body.querySelectorAll('h1[id], h2[id], h3[id], h4[id], h5[id], h6[id]')
      );
      if (!headings.length) return;

      // The open panel covers the title, so it has to close on everything a
      // reader would expect to dismiss an overlay with — picking a heading,
      // pressing Escape, or touching the article underneath.
      var bar = root.querySelector('[data-article-toc-bar]');
      if (bar) {
        links.forEach(function (link) {
          if (!bar.contains(link)) return;
          link.addEventListener('click', function () {
            bar.open = false;
          });
        });

        document.addEventListener('click', function (event) {
          if (bar.open && !bar.contains(event.target)) bar.open = false;
        });

        document.addEventListener('keydown', function (event) {
          if (event.key !== 'Escape' || !bar.open) return;
          bar.open = false;
          var summary = bar.querySelector('summary');
          if (summary) summary.focus();
        });
      }

      var stickyHeader = document.querySelector('[data-sticky-header]');
      var offset = 144;
      var current = null;
      var pending = false;

      function measure() {
        var height = stickyHeader ? stickyHeader.getBoundingClientRect().height : 104;
        offset = height + 40;
      }

      function setActive(id) {
        if (id === current) return;
        current = id;

        links.forEach(function (link) {
          var item = link.parentNode;
          if (!item || !item.classList) return;

          if (link.getAttribute('href') === '#' + id) {
            item.classList.add('article-toc__item--active');
          } else {
            item.classList.remove('article-toc__item--active');
          }
        });
      }

      function update() {
        pending = false;

        var index = 0;
        for (var i = 0; i < headings.length; i++) {
          if (headings[i].getBoundingClientRect().top - offset > 1) break;
          index = i;
        }

        setActive(headings[index].id);
      }

      function onScroll() {
        if (pending) return;
        pending = true;
        requestAnimationFrame(update);
      }

      function onResize() {
        measure();
        onScroll();
      }

      measure();
      update();

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize);
    });
  }

  initArticle();
  document.addEventListener('shopify:section:load', initArticle);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
  function parseBlogSearchSynonyms(raw) {
    const map = {};
    String(raw || '')
      .split(/\r?\n/)
      .forEach((line) => {
        const trimmed = line.trim();
        if (!trimmed) return;
        const parts = trimmed.split(/[|=]/);
        if (parts.length < 2) return;
        const source = parts[0].trim().toLowerCase();
        const target = parts.slice(1).join('|').trim();
        if (source && target) map[source] = target;
      });
    return map;
  }

  function expandBlogSearchQuery(query, map) {
    let next = String(query || '').trim();
    if (!next) return next;

    const keys = Object.keys(map).sort((a, b) => b.length - a.length);
    keys.forEach((key) => {
      if (next.toLowerCase() === key) {
        next = map[key];
      }
    });

    return next
      .split(/\s+/)
      .map((token) => map[token.toLowerCase()] || token)
      .join(' ');
  }

  function parseSectionHtml(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  async function fetchSectionHtml(url, sectionKey) {
    const fetchUrl = new URL(url, window.location.href);
    fetchUrl.searchParams.set('sections', sectionKey);
    const response = await fetch(fetchUrl.toString());
    if (!response.ok) {
      throw new Error('Failed to load articles');
    }
    const data = await response.json();
    return data[sectionKey] || '';
  }

  function blogPrefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function wait(ms) {
    return new Promise((resolve) => window.setTimeout(resolve, ms));
  }

  function blogUsesSkeleton(listing) {
    return listing.dataset.showSkeleton === 'true';
  }

  function showBlogSkeleton(content, listing) {
    const template = listing.querySelector('[data-blog-skeleton]');
    if (!template) return false;
    content.innerHTML = template.innerHTML;
    return true;
  }

  function appendBlogSkeletonCards(grid, listing, count) {
    const template = listing.querySelector('[data-blog-skeleton-card]');
    if (!template || !grid || count < 1) return [];

    const skeletons = [];
    for (let index = 0; index < count; index += 1) {
      const node = template.content.firstElementChild?.cloneNode(true);
      if (!node) continue;
      grid.appendChild(node);
      skeletons.push(node);
    }
    return skeletons;
  }

  async function fadeBlogContent(content, nextHtml) {
    if (blogPrefersReducedMotion()) {
      content.innerHTML = nextHtml;
      return;
    }

    content.classList.add('is-updating');
    await wait(80);
    content.innerHTML = nextHtml;

    const cards = content.querySelectorAll('[data-blog-card]:not(.blog__card--skeleton)');
    cards.forEach((card) => {
      card.classList.add('is-entering');
      card.classList.remove('is-visible');
    });

    void content.offsetHeight;
    content.classList.remove('is-updating');
    revealBlogCards(cards);
  }

  function revealBlogCards(cards) {
    if (!cards?.length) return;

    if (blogPrefersReducedMotion()) {
      cards.forEach((card) => {
        card.classList.remove('is-entering');
        card.classList.add('is-visible');
      });
      return;
    }

    cards.forEach((card) => {
      card.classList.add('is-entering');
      card.classList.remove('is-visible');
    });

    window.requestAnimationFrame(() => {
      cards.forEach((card) => {
        card.classList.add('is-visible');
        card.classList.remove('is-entering');
      });
    });
  }

  async function loadMoreArticles(listing, loadMoreWrap) {
    const nextUrl = loadMoreWrap.dataset.nextUrl;
    if (!nextUrl || loadMoreWrap.getAttribute('aria-busy') === 'true') return;

    const isSearch = listing.dataset.searchActive === 'true';
    const sectionKey = isSearch
      ? listing.dataset.searchSectionId || 'blog-search-results'
      : listing.dataset.sectionId;
    const grid = listing.querySelector('[data-blog-grid]');
    const skeletonCount = Number(listing.dataset.initialPosts) || 6;
    let skeletons = [];

    loadMoreWrap.setAttribute('aria-busy', 'true');

    if (blogUsesSkeleton(listing) && grid) {
      skeletons = appendBlogSkeletonCards(grid, listing, skeletonCount);
    }

    try {
      const sectionHtml = await fetchSectionHtml(nextUrl, sectionKey);
      const doc = parseSectionHtml(sectionHtml);
      const sourceGrid = doc.querySelector('[data-blog-grid]');

      skeletons.forEach((skeleton) => skeleton.remove());

      if (grid && sourceGrid) {
        const newCards = [];
        sourceGrid.querySelectorAll('[data-blog-card]').forEach((card) => {
          card.classList.add('is-entering');
          grid.appendChild(card);
          newCards.push(card);
        });
        revealBlogCards(newCards);
      }

      const sourceLoadMore = doc.querySelector('[data-blog-load-more]');
      if (sourceLoadMore?.dataset.nextUrl) {
        loadMoreWrap.dataset.nextUrl = sourceLoadMore.dataset.nextUrl;
        loadMoreWrap.hidden = false;
      } else {
        loadMoreWrap.hidden = true;
        delete loadMoreWrap.dataset.nextUrl;
      }
    } catch (error) {
      skeletons.forEach((skeleton) => skeleton.remove());
      console.error(error);
    } finally {
      loadMoreWrap.removeAttribute('aria-busy');
    }
  }

  document.querySelectorAll('[data-blog-listing]').forEach((listing) => {
    const content = listing.querySelector('[data-blog-content]');
    if (!content) return;

    const defaultContentHtml = content.innerHTML;
    const form = listing.querySelector('[data-blog-search]');
    const input = form?.querySelector('[name="q"]');
    const filter = listing.querySelector('[data-blog-filter]');
    const filterLabel = filter?.querySelector('[data-blog-filter-label]');
    const synonymSource = listing.querySelector('[id^="BlogSearchSynonyms-"]');
    const debounceMs = Number(form?.getAttribute('data-debounce')) || 400;
    const searchSectionKey = listing.dataset.searchSectionId || 'blog-search-results';
    const sectionKey = listing.dataset.sectionId;
    let timer;

    let synonymRaw = '';
    try {
      synonymRaw = JSON.parse(synonymSource?.textContent || '""');
    } catch (error) {
      synonymRaw = synonymSource?.textContent || '';
    }

    const synonyms = parseBlogSearchSynonyms(synonymRaw);

    function getActiveFilterOption() {
      return filter?.querySelector('.blog__filter-option[aria-current="true"]') || null;
    }

    function getFilterState() {
      const active = getActiveFilterOption();
      return {
        value: active?.dataset.value || '',
        label: active?.querySelector('.blog__filter-option-label')?.textContent?.trim() || '',
        url: active?.dataset.url || listing.dataset.blogUrl,
      };
    }

    listing.addEventListener('click', (event) => {
      const loadMoreWrap = event.target.closest('[data-blog-load-more]');
      if (!loadMoreWrap || !listing.contains(loadMoreWrap)) return;

      const control = event.target.closest('button, a');
      if (!control) return;

      event.preventDefault();
      loadMoreArticles(listing, loadMoreWrap);
    });

    async function replaceContent(url, key, selector) {
      const useSkeleton = blogUsesSkeleton(listing);

      if (useSkeleton) {
        showBlogSkeleton(content, listing);
      } else if (!blogPrefersReducedMotion()) {
        content.classList.add('is-updating');
      }

      try {
        const sectionHtml = await fetchSectionHtml(url, key);
        const doc = parseSectionHtml(sectionHtml);
        const source = doc.querySelector(selector);
        if (!source) return;
        await fadeBlogContent(content, source.innerHTML);
      } catch (error) {
        console.error(error);
        if (!useSkeleton) content.classList.remove('is-updating');
      }
    }

    async function refreshListing() {
      const query = input ? expandBlogSearchQuery(input.value, synonyms).trim() : '';
      const filterState = getFilterState();
      const tag = filterState.value;
      const tagLabel = filterState.label;

      if (query) {
        let searchQuery = query;
        if (tag && tagLabel) {
          searchQuery = `${query} ${tagLabel}`;
        }

        const searchRoot = listing.dataset.searchUrl || '/search';
        const perPage = listing.dataset.initialPosts || '6';
        const searchUrl = `${searchRoot}?q=${encodeURIComponent(searchQuery)}&type=article&articles_per_page=${encodeURIComponent(perPage)}`;

        await replaceContent(searchUrl, searchSectionKey, '[data-blog-search-results]');
        listing.dataset.searchActive = 'true';
        listing.dataset.filterActive = tag ? 'true' : 'false';
        return;
      }

      if (tag) {
        await replaceContent(filterState.url, sectionKey, '[data-blog-content]');
        listing.dataset.searchActive = 'false';
        listing.dataset.filterActive = 'true';
        return;
      }

      if (listing.dataset.defaultIsTagged === 'true' || listing.dataset.filterActive === 'true') {
        await replaceContent(listing.dataset.blogUrl, sectionKey, '[data-blog-content]');
      } else {
        await fadeBlogContent(content, defaultContentHtml);
      }

      listing.dataset.searchActive = 'false';
      listing.dataset.filterActive = 'false';
      listing.dataset.defaultIsTagged = 'false';
    }

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      refreshListing();
    });

    input?.addEventListener('input', () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(refreshListing, debounceMs);
    });

    filter?.addEventListener('click', (event) => {
      const option = event.target.closest('.blog__filter-option');
      if (!option || !filter.contains(option)) return;

      event.preventDefault();

      filter.querySelectorAll('.blog__filter-option').forEach((button) => {
        button.removeAttribute('aria-current');
      });
      option.setAttribute('aria-current', 'true');

      if (filterLabel) {
        filterLabel.textContent =
          option.querySelector('.blog__filter-option-label')?.textContent?.trim() || '';
      }

      filter.open = false;
      refreshListing();
    });

    document.addEventListener('click', (event) => {
      if (!filter?.open) return;
      if (filter.contains(event.target)) return;
      filter.open = false;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  /**
   * The drawer owns every cart write on the storefront. Nothing here builds
   * markup: each request asks the Cart API to return this section re-rendered
   * and the reply is dropped into the panel, so Liquid stays the only place
   * that knows how to format a price or translate a string.
   */
  (function () {
    var SECTION = 'cart-drawer';
    var RETURN_KEY = 'happykids:last-storefront';
    var RETURN_PARAM = 'open_cart';
    var drawer = null;

    function root() {
      if (drawer && drawer.isConnected) return drawer;
      drawer = document.querySelector('[data-cart-drawer]');
      return drawer;
    }

    function content() {
      var el = root();
      return el ? el.querySelector('[data-cart-drawer-content]') : null;
    }

    function sectionId() {
      var el = root();
      return el ? el.getAttribute('data-section-id') || SECTION : SECTION;
    }

    function busy(state) {
      var el = content();
      if (el) el.setAttribute('aria-busy', state ? 'true' : 'false');
    }

    function fail(message) {
      var el = content();
      if (!el) return;

      var box = el.querySelector('[data-cart-drawer-error]');
      if (box) box.textContent = message || '';
    }

    function open() {
      var el = root();
      if (!el) return;

      if (!el.open) el.showModal();
    }

    function close() {
      var el = root();
      if (el && el.open) el.close();
    }

    function cartPath() {
      var el = root();
      var href = el && el.getAttribute('data-cart-url');
      if (!href) return '/cart';

      try {
        return new URL(href, window.location.origin).pathname.replace(/\/$/, '') || '/';
      } catch (error) {
        return '/cart';
      }
    }

    function onCartPage() {
      return window.location.pathname.replace(/\/$/, '') === cartPath();
    }

    function homePath() {
      var el = root();
      return (el && el.getAttribute('data-root-url')) || '/';
    }

    function withOpenCart(path) {
      var next = path || '/';
      if (next.indexOf(RETURN_PARAM + '=') !== -1) return next;
      return next + (next.indexOf('?') === -1 ? '?' : '&') + RETURN_PARAM + '=1';
    }

    /**
     * Shopify checkout's bag icon always lands on /cart. The drawer cannot
     * open there, so the cart page sends the customer back to the last shop
     * page they were on and asks this script to open on arrival.
     */
    function leaveCartPage() {
      if (window.Shopify && Shopify.designMode) return false;
      if (!onCartPage()) return false;

      var stored = '';
      try {
        stored = sessionStorage.getItem(RETURN_KEY) || '';
      } catch (error) {}

      var next = stored || homePath();
      var pathOnly = next.split('?')[0].replace(/\/$/, '');
      if (!pathOnly || pathOnly === cartPath()) next = homePath();

      window.location.replace(withOpenCart(next));
      return true;
    }

    function rememberStorefront() {
      if (window.Shopify && Shopify.designMode) return;
      if (onCartPage()) return;

      var params = new URLSearchParams(window.location.search);
      params.delete(RETURN_PARAM);
      var search = params.toString();
      var stored =
        window.location.pathname + (search ? '?' + search : '') + window.location.hash;

      try {
        sessionStorage.setItem(RETURN_KEY, stored);
      } catch (error) {}
    }

    function openReturnedCart() {
      var params = new URLSearchParams(window.location.search);
      if (params.get(RETURN_PARAM) !== '1') return;

      open();
      refresh();

      params.delete(RETURN_PARAM);
      var search = params.toString();
      var clean =
        window.location.pathname + (search ? '?' + search : '') + window.location.hash;
      if (history.replaceState) history.replaceState({}, '', clean);
    }

    /**
     * Carries the new item count out to everything in the page that shows one:
     * the header's badge, and any element whose text spells the count out, like
     * the "Cart, 2 items" link in the mobile panel. Only the digits in those
     * strings are replaced, so whatever the merchant's language wrote around
     * them survives untouched.
     */
    function count(total) {
      var number = parseInt(total, 10);
      if (isNaN(number)) return;

      var badges = document.querySelectorAll('[data-cart-count]');
      for (var i = 0; i < badges.length; i++) {
        badges[i].textContent = number;

        if (number > 0) {
          badges[i].removeAttribute('hidden');
        } else {
          badges[i].setAttribute('hidden', '');
        }

        /* The badge is `aria-hidden`, so the link around it owns the spoken
           count and has to be brought along. */
        var labelled = badges[i].closest('[aria-label]');
        if (labelled) {
          labelled.setAttribute(
            'aria-label',
            labelled.getAttribute('aria-label').replace(/\d+/, number)
          );
        }
      }

      var labels = document.querySelectorAll('[data-cart-label]');
      for (var j = 0; j < labels.length; j++) {
        labels[j].textContent = labels[j].textContent.replace(/\d+/, number);
      }
    }

    /**
     * Only the contents are swapped. Replacing the dialog itself would drop the
     * open state and the browser's focus trap along with it.
     */
    function swap(html) {
      var target = content();
      if (!target || !html) return;

      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var next = parsed.querySelector('[data-cart-drawer-content]');
      if (!next) return;

      target.innerHTML = next.innerHTML;
      target.setAttribute(
        'data-needs-recommendations',
        next.getAttribute('data-needs-recommendations') || 'false'
      );

      var total = next.getAttribute('data-cart-total');
      if (total !== null) {
        target.setAttribute('data-cart-total', total);
        count(total);
      }

      var recommendFor = next.getAttribute('data-recommend-for');
      if (recommendFor) {
        target.setAttribute('data-recommend-for', recommendFor);
      } else {
        target.removeAttribute('data-recommend-for');
      }

      recommend();
    }

    function apply(data) {
      if (!data) return;

      if (data.sections) {
        var key = Object.keys(data.sections)[0];
        if (key) swap(data.sections[key]);
      }
    }

    function post(url, body) {
      busy(true);
      fail('');

      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error(data.description || data.message || '');
            return data;
          });
        })
        .then(function (data) {
          apply(data);
          return data;
        })
        .catch(function (error) {
          fail(error.message);
        })
        .then(function () {
          busy(false);
        });
    }

    function sectionBody(extra) {
      var body = extra || {};
      body.sections = sectionId();
      body.sections_url = window.location.pathname;
      return body;
    }

    function add(id, quantity) {
      return post('/cart/add.js', sectionBody({ items: [{ id: id, quantity: quantity || 1 }] }));
    }

    function change(line, quantity) {
      return post('/cart/change.js', sectionBody({ line: line, quantity: quantity }));
    }

    /**
     * Pulls the whole section fresh. Used by the header cart button, where no
     * write happened but the page HTML may have been served from the edge
     * before the cart was last touched.
     */
    function refresh() {
      busy(true);

      return fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionId()))
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          apply({ sections: data });
        })
        .catch(function () {})
        .then(function () {
          busy(false);
        });
    }

    /**
     * The fallback source for "Add more". Re-rendering this same section
     * through the recommendations endpoint is what gives its Liquid a
     * populated `recommendations` object — no second section, and the
     * suggestions still come out of Liquid rather than being assembled here.
     *
     * `related` rather than `complementary`: complementary only returns
     * anything once the merchant has paired products up in Search & Discovery,
     * and a fallback that is usually empty is not a fallback.
     */
    function recommend() {
      var el = content();
      if (!el) return;
      if (el.getAttribute('data-needs-recommendations') !== 'true') return;

      var productId = el.getAttribute('data-recommend-for');
      if (!productId) return;

      el.setAttribute('data-needs-recommendations', 'false');

      var url =
        '/recommendations/products?section_id=' +
        encodeURIComponent(sectionId()) +
        '&product_id=' +
        encodeURIComponent(productId) +
        '&limit=' +
        encodeURIComponent(el.getAttribute('data-recommend-limit') || 4) +
        '&intent=related';

      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(swap)
        .catch(function () {});
    }

    function lineOf(node) {
      var item = node.closest('[data-cart-line]');
      return item ? parseInt(item.getAttribute('data-cart-line'), 10) : 0;
    }

    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;

      var opener = event.target.closest('[data-cart-drawer-open]');
      if (opener) {
        if (!root()) return;

        event.preventDefault();

        /* The mobile cart link lives inside the header's <details> panel,
           which would otherwise stay open behind the drawer. */
        var panel = opener.closest('details[open]');
        if (panel) panel.open = false;

        open();
        refresh();
        return;
      }

      var el = root();
      if (!el || !el.open) return;

      if (event.target.closest('[data-action="cart-drawer-close"]')) {
        close();
        return;
      }

      /* The panel fills the dialog, so a click outside it is a backdrop click. */
      if (!event.target.closest('[data-cart-drawer-panel]')) {
        close();
        return;
      }

      var remove = event.target.closest('[data-action="cart-drawer-remove"]');
      if (remove) {
        change(lineOf(remove), 0);
        return;
      }

      var suggestion = event.target.closest('[data-action="cart-drawer-add"]');
      if (suggestion) {
        add(suggestion.getAttribute('data-variant-id'), 1);
        return;
      }

      var step = event.target.closest('[data-quantity-step]');
      if (step) {
        var field = step.parentElement.querySelector('[data-quantity-input]');
        if (!field) return;

        var next = parseInt(field.value, 10) + parseInt(step.getAttribute('data-quantity-step'), 10);
        if (next < 1) return;

        change(lineOf(step), next);
      }
    });

    /* Typing straight into the stepper's number field. */
    document.addEventListener('change', function (event) {
      var el = root();
      if (!el || !el.open) return;

      var field = event.target.closest('[data-quantity-input]');
      if (!field) return;
      if (!field.closest('[data-cart-line]')) return;

      var next = parseInt(field.value, 10);
      if (isNaN(next) || next < 1) next = 1;

      change(lineOf(field), next);
    });

    /**
     * Every add-to-cart form in the theme, matched by where it posts rather
     * than by class, so a section added later is picked up without changes
     * here. The form stays a real form: this only takes over when the fetch
     * can run.
     */
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.action || form.action.indexOf('/cart/add') === -1) return;
      if (!root()) return;

      event.preventDefault();

      var data = new FormData(form);
      data.append('sections', sectionId());
      data.append('sections_url', window.location.pathname);

      busy(true);
      fail('');
      open();

      fetch('/cart/add', { method: 'POST', headers: { Accept: 'application/json' }, body: data })
        .then(function (response) {
          return response.json().then(function (payload) {
            if (!response.ok) throw new Error(payload.description || payload.message || '');
            return payload;
          });
        })
        .then(apply)
        .catch(function (error) {
          fail(error.message);
        })
        .then(function () {
          busy(false);
        });
    });

    /* The drawer is hidden by default, so opening it is the only way the
       merchant can see what they are editing. */
    document.addEventListener('shopify:section:select', function (event) {
      if (event.target.querySelector('[data-cart-drawer]')) open();
    });

    document.addEventListener('shopify:section:deselect', function (event) {
      if (event.target.querySelector('[data-cart-drawer]')) close();
    });

    if (leaveCartPage()) return;
    rememberStorefront();
    openReturnedCart();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  /**
   * Animates the accordion so a question morphs open instead of snapping. The
   * card's padding, radius, background and glyphs are CSS transitions in
   * snippets/faq-item.liquid; only the panel height needs measuring, which is
   * what this does. Both run on --faq-item-duration so they land together.
   */
  var FAQ_EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';

  function faqDuration(details) {
    var value = getComputedStyle(details).getPropertyValue('--faq-item-duration').trim();
    if (value.slice(-2) === 'ms') return parseFloat(value);
    if (value.slice(-1) === 's') return parseFloat(value) * 1000;
    return 420;
  }

  function faqReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* Measure before cancelling — a running animation *is* the current height. */
  function faqStop(details, panel) {
    var height = panel.getBoundingClientRect().height;
    if (details.faqAnimation) {
      details.faqAnimation.cancel();
      details.faqAnimation = null;
    }
    return height;
  }

  function faqSlide(details, panel, from, to, onFinish) {
    /**
     * `fill: 'forwards'` holds the last frame. Without it the height snaps back
     * to `auto` the instant the animation ends, which flashes the whole panel
     * for a frame before `onfinish` gets to remove `open`. The fill is dropped
     * again below, once the element is in its resting state.
     */
    var animation = panel.animate([{ height: from + 'px' }, { height: to + 'px' }], {
      duration: faqDuration(details),
      easing: FAQ_EASE,
      fill: 'forwards',
    });

    details.faqAnimation = animation;

    animation.onfinish = function () {
      if (onFinish) onFinish();

      /* Never leave a filled animation behind — it would pin the panel to a
         stale height when the content reflows. */
      animation.cancel();
      if (details.faqAnimation === animation) details.faqAnimation = null;
    };
  }

  function faqOpen(details) {
    var panel = details.querySelector('[data-faq-panel]');
    if (!panel) return;

    var from = details.open ? faqStop(details, panel) : 0;

    details.removeAttribute('data-closing');
    details.open = true;
    if (faqReducedMotion()) return;

    faqSlide(details, panel, from, panel.scrollHeight);
  }

  function faqClose(details) {
    var panel = details.querySelector('[data-faq-panel]');
    if (!panel) return;

    var from = faqStop(details, panel);

    /* Set first: the card sheds its padding and radius as the panel collapses. */
    details.setAttribute('data-closing', '');

    function settle() {
      details.open = false;
      details.removeAttribute('data-closing');
    }

    if (faqReducedMotion()) {
      settle();
      return;
    }

    faqSlide(details, panel, from, 0, settle);
  }

  function faqCloseSiblings(root, current) {
    root.querySelectorAll('[data-faq-item]').forEach(function (other) {
      if (other !== current && other.open) faqClose(other);
    });
  }

  function initFaq() {
    document.querySelectorAll('[data-faq]').forEach(function (root) {
      if (root.dataset.faqReady === 'true') return;
      root.dataset.faqReady = 'true';

      root.querySelectorAll('[data-faq-item]').forEach(function (details) {
        /**
         * A `name` group is closed synchronously by the browser, which leaves
         * nothing on screen to animate. With the script running, exclusivity
         * moves here so the outgoing card collapses while the next expands.
         */
        details.removeAttribute('name');

        var summary = details.querySelector('summary');
        if (!summary) return;

        /* Enter and Space on a <summary> dispatch a click, so this covers both. */
        summary.addEventListener('click', function (event) {
          event.preventDefault();

          if (details.open && !details.hasAttribute('data-closing')) {
            faqClose(details);
            return;
          }

          faqCloseSiblings(root, details);
          faqOpen(details);
        });
      });
    });
  }

  initFaq();
  document.addEventListener('shopify:section:load', initFaq);

  /* The intercepted click would otherwise break selecting a block in the editor. */
  document.addEventListener('shopify:block:select', function (event) {
    var details = event.target;
    if (!details.matches || !details.matches('[data-faq-item]')) return;

    var root = details.closest('[data-faq]');
    if (root) faqCloseSiblings(root, details);
    faqOpen(details);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /**
   * Slides the header up out of view once the page has scrolled past 30px, and
   * brings it back on the first upward scroll from any point in the page.
   *
   * The script only ever toggles classes; the movement itself is the CSS
   * transition on the sticky wrapper.
   */
  function initStickyHeader() {
    var header = document.querySelector('[data-sticky-header]');
    if (!header) return;

    var wrapper = header.closest('.shopify-section') || header.parentElement;
    if (!wrapper || wrapper.dataset.stickyHeaderReady === 'true') return;
    wrapper.dataset.stickyHeaderReady = 'true';

    /* The header holds its place for the first 30px, so a nudge never hides it. */
    var HIDE_AFTER = 30;
    /* Movement below this is treated as noise rather than a change of direction. */
    var THRESHOLD = 4;

    var lastY = Math.max(window.scrollY, 0);
    var revealed = true;
    var pending = false;

    function update(instant) {
      pending = false;

      var y = Math.max(window.scrollY, 0);
      var delta = y - lastY;

      if (delta > THRESHOLD || delta < -THRESHOLD) {
        revealed = delta < 0;
        lastY = y;
      }

      /* Near the top the header always belongs on screen, whichever way we came. */
      if (y <= HIDE_AFTER) revealed = true;

      wrapper.classList.toggle('header-group--instant', instant === true);
      wrapper.classList.toggle('header-group--floating', y > 0);
      wrapper.classList.toggle('header-group--hidden', !revealed);
    }

    function onScroll() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    update(true);
  }

  initStickyHeader();
  document.addEventListener('shopify:section:load', initStickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
  /**
   * Animates the steps so one body collapses while the next expands, instead of
   * the swap happening in a single frame. The dimming, the rule segment and the
   * number offset are CSS transitions above; only the body height needs
   * measuring, which is what this does. Everything runs on --how-duration so it
   * all lands together.
   */
  var HOW_EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';

  function howDuration(details) {
    var value = getComputedStyle(details).getPropertyValue('--how-duration').trim();
    if (value.slice(-2) === 'ms') return parseFloat(value);
    if (value.slice(-1) === 's') return parseFloat(value) * 1000;
    return 420;
  }

  function howReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* Measure before cancelling — a running animation *is* the current height. */
  function howStop(details, panel) {
    var height = panel.getBoundingClientRect().height;
    if (details.howAnimation) {
      details.howAnimation.cancel();
      details.howAnimation = null;
    }
    return height;
  }

  function howSlide(details, panel, from, to, onFinish) {
    /**
     * `fill: 'forwards'` holds the last frame. Without it the height snaps back
     * to `auto` the instant the animation ends, which flashes the whole body
     * for a frame before `onfinish` gets to remove `open`. The fill is dropped
     * again below, once the element is in its resting state.
     */
    var animation = panel.animate([{ height: from + 'px' }, { height: to + 'px' }], {
      duration: howDuration(details),
      easing: HOW_EASE,
      fill: 'forwards',
    });

    details.howAnimation = animation;

    animation.onfinish = function () {
      if (onFinish) onFinish();

      /* Never leave a filled animation behind — it would pin the body to a
         stale height when the content reflows. */
      animation.cancel();
      if (details.howAnimation === animation) details.howAnimation = null;
    };
  }

  function howOpen(details) {
    var panel = details.querySelector('[data-how-panel]');
    if (!panel) return;

    var from = details.open ? howStop(details, panel) : 0;

    details.removeAttribute('data-closing');
    details.open = true;
    if (howReducedMotion()) return;

    howSlide(details, panel, from, panel.scrollHeight);
  }

  function howClose(details) {
    var panel = details.querySelector('[data-how-panel]');
    if (!panel) return;

    var from = howStop(details, panel);

    /* Set first: the step dims and drops its rule segment as the body collapses. */
    details.setAttribute('data-closing', '');

    function settle() {
      details.open = false;
      details.removeAttribute('data-closing');
    }

    if (howReducedMotion()) {
      settle();
      return;
    }

    howSlide(details, panel, from, 0, settle);
  }

  function howCloseSiblings(root, current) {
    root.querySelectorAll('[data-how-item]').forEach(function (other) {
      if (other !== current && other.open) howClose(other);
    });
  }

  function initHowItWorks() {
    document.querySelectorAll('[data-how-steps]').forEach(function (root) {
      if (root.dataset.howReady === 'true') return;
      root.dataset.howReady = 'true';

      root.querySelectorAll('[data-how-item]').forEach(function (details) {
        /**
         * A `name` group is closed synchronously by the browser, which leaves
         * nothing on screen to animate. With the script running, exclusivity
         * moves here so the outgoing step collapses while the next expands.
         */
        details.removeAttribute('name');

        var summary = details.querySelector('summary');
        if (!summary) return;

        /* Enter and Space on a <summary> dispatch a click, so this covers both. */
        summary.addEventListener('click', function (event) {
          event.preventDefault();

          if (details.open && !details.hasAttribute('data-closing')) {
            howClose(details);
            return;
          }

          howCloseSiblings(root, details);
          howOpen(details);
        });
      });
    });
  }

  initHowItWorks();
  document.addEventListener('shopify:section:load', initHowItWorks);

  /* The intercepted click would otherwise break selecting a block in the editor.
     The block attributes sit on the .how__step wrapper, not on the <details>. */
  document.addEventListener('shopify:block:select', function (event) {
    if (!event.target.querySelector) return;

    var details = event.target.querySelector('[data-how-item]');
    if (!details) return;

    var root = details.closest('[data-how-steps]');
    if (root) howCloseSiblings(root, details);
    howOpen(details);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offer-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function storage(kind) {
      try {
        return kind === 'session' ? window.sessionStorage : window.localStorage;
      } catch (error) {
        return null;
      }
    }

    function editing() {
      return window.Shopify && Shopify.designMode;
    }

    function subscribedKey(el) {
      return el.getAttribute('data-storage-key') + '-subscribed';
    }

    function hasSubscribed(el) {
      var local = storage('local');
      if (!local) return false;
      return !!(local.getItem(subscribedKey(el)) || local.getItem('offer-popup-subscribed'));
    }

    function rememberSubscribed(el) {
      if (editing()) return;
      var local = storage('local');
      if (!local) return;
      local.setItem(subscribedKey(el), '1');
      local.setItem('offer-popup-subscribed', '1');
    }

    function dismissed(el) {
      if (hasSubscribed(el)) return true;

      var key = el.getAttribute('data-storage-key');
      var frequency = el.getAttribute('data-frequency');
      if (frequency === 'always') return false;

      if (frequency === 'session') {
        var session = storage('session');
        return !!(session && session.getItem(key));
      }

      var local = storage('local');
      if (!local) return false;

      var raw = local.getItem(key);
      if (!raw) return false;
      if (frequency === 'once') return true;

      var days = parseInt(el.getAttribute('data-days'), 10);
      if (isNaN(days) || days < 1) days = 7;

      var seen = parseInt(raw, 10);
      if (isNaN(seen)) return true;
      return Date.now() - seen < days * 86400000;
    }

    function remember(el) {
      if (editing()) return;

      var key = el.getAttribute('data-storage-key');
      var frequency = el.getAttribute('data-frequency');
      if (frequency === 'always') return;

      if (frequency === 'session') {
        var session = storage('session');
        if (session) session.setItem(key, '1');
        return;
      }

      var local = storage('local');
      if (!local) return;

      if (frequency === 'days') {
        local.setItem(key, String(Date.now()));
        return;
      }

      local.setItem(key, '1');
    }

    function reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function open(el) {
      if (!el || el.open) return;
      el.classList.remove('offer-popup--closing');
      if (typeof el.showModal === 'function') el.showModal();
      // Park focus on the dialog itself. Left to the browser, focus lands on the
      // close button and, with no prior interaction, shows its focus ring.
      el.focus({ preventScroll: true });
      if (reducedMotion()) {
        el.classList.add('offer-popup--visible');
        return;
      }
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          el.classList.add('offer-popup--visible');
        });
      });
    }

    function close(el) {
      if (!el || !el.open || el.dataset.closing === 'true') return;

      if (reducedMotion() || !el.classList.contains('offer-popup--visible')) {
        el.classList.remove('offer-popup--visible');
        el.close();
        return;
      }

      el.dataset.closing = 'true';
      el.classList.remove('offer-popup--visible');
      el.classList.add('offer-popup--closing');

      var finished = false;
      var done = function () {
        if (finished) return;
        finished = true;
        el.removeEventListener('transitionend', onEnd);
        delete el.dataset.closing;
        el.classList.remove('offer-popup--closing');
        if (el.open) el.close();
      };
      var onEnd = function (event) {
        if (event.target !== el) return;
        done();
      };

      el.addEventListener('transitionend', onEnd);
      window.setTimeout(done, 480);
    }

    function formState(el) {
      var node = el.querySelector('[data-offer-popup-state]');
      return node ? node.getAttribute('data-offer-popup-state') : '';
    }

    function postedFromUrl() {
      try {
        var params = new URLSearchParams(window.location.search);
        return params.get('customer_posted') === 'true' || params.get('contact_posted') === 'true';
      } catch (error) {
        return false;
      }
    }

    function finishSubscribe(el) {
      rememberSubscribed(el);
      remember(el);
      close(el);
    }

    function bindForm(el) {
      var form = el.querySelector('.offer-popup__form');
      if (!form || form.dataset.offerBound === 'true') return;
      form.dataset.offerBound = 'true';

      form.addEventListener('submit', function (event) {
        if (editing()) return;
        event.preventDefault();
        rememberSubscribed(el);

        var button = form.querySelector('[type="submit"]');
        if (button) button.disabled = true;

        fetch(form.action, {
          method: (form.method || 'POST').toUpperCase(),
          body: new FormData(form),
        })
          .then(function () {
            finishSubscribe(el);
          })
          .catch(function () {
            form.submit();
          });
      });
    }

    function schedule(el) {
      if (!el) return;

      bindForm(el);

      var state = formState(el);
      if (state === 'success' || postedFromUrl()) {
        rememberSubscribed(el);
        return;
      }

      if (state === 'error') {
        open(el);
        return;
      }

      if (editing()) return;
      if (el.getAttribute('data-enabled') !== 'true') return;
      if (dismissed(el)) return;

      var delay = parseInt(el.getAttribute('data-delay'), 10);
      if (isNaN(delay) || delay < 0) delay = 0;

      window.setTimeout(function () {
        if (dismissed(el)) return;
        open(el);
      }, delay * 1000);
    }

    document.addEventListener(
      'close',
      function (event) {
        var el = event.target;
        if (!el || !el.hasAttribute || !el.hasAttribute('data-offer-popup')) return;
        el.classList.remove('offer-popup--visible', 'offer-popup--closing');
        delete el.dataset.closing;
        remember(el);
      },
      true
    );

    document.addEventListener(
      'cancel',
      function (event) {
        var el = event.target;
        if (!el || !el.hasAttribute || !el.hasAttribute('data-offer-popup')) return;
        event.preventDefault();
        close(el);
      },
      true
    );

    document.addEventListener('click', function (event) {
      var el = event.target.closest('[data-offer-popup]');
      if (!el) return;

      if (event.target.closest('[data-action="offer-popup-close"]')) {
        close(el);
        return;
      }

      if (!event.target.closest('[data-offer-popup-panel]')) {
        close(el);
      }
    });

    document.addEventListener('shopify:section:select', function (event) {
      var el = event.target.querySelector('[data-offer-popup]');
      if (el) open(el);
    });

    document.addEventListener('shopify:section:deselect', function (event) {
      var el = event.target.querySelector('[data-offer-popup]');
      if (el) close(el);
    });

    document.querySelectorAll('[data-offer-popup]').forEach(schedule);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["policy-details"]) return;
  try {
    
    function initArticle() {
      document.querySelectorAll('[data-article]').forEach(function (root) {
        if (root.dataset.articleReady === 'true') return;
        root.dataset.articleReady = 'true';

        var body = root.querySelector('[data-article-body]');
        var links = Array.prototype.slice.call(root.querySelectorAll('[data-toc-link]'));
        if (!body || !links.length) return;

        var headings = Array.prototype.slice.call(
          body.querySelectorAll('h1[id], h2[id], h3[id], h4[id], h5[id], h6[id]')
        );
        if (!headings.length) return;

        var bar = root.querySelector('[data-article-toc-bar]');
        if (bar) {
          links.forEach(function (link) {
            if (!bar.contains(link)) return;
            link.addEventListener('click', function () {
              bar.open = false;
            });
          });

          document.addEventListener('click', function (event) {
            if (bar.open && !bar.contains(event.target)) bar.open = false;
          });

          document.addEventListener('keydown', function (event) {
            if (event.key !== 'Escape' || !bar.open) return;
            bar.open = false;
            var summary = bar.querySelector('summary');
            if (summary) summary.focus();
          });
        }

        var stickyHeader = document.querySelector('[data-sticky-header]');
        var offset = 144;
        var current = null;
        var pending = false;

        function measure() {
          var height = stickyHeader ? stickyHeader.getBoundingClientRect().height : 104;
          offset = height + 40;
        }

        function setActive(id) {
          if (id === current) return;
          current = id;

          links.forEach(function (link) {
            var item = link.parentNode;
            if (!item || !item.classList) return;

            if (link.getAttribute('href') === '#' + id) {
              item.classList.add('article-toc__item--active');
            } else {
              item.classList.remove('article-toc__item--active');
            }
          });
        }

        function update() {
          pending = false;

          var index = 0;
          for (var i = 0; i < headings.length; i++) {
            if (headings[i].getBoundingClientRect().top - offset > 1) break;
            index = i;
          }

          setActive(headings[index].id);
        }

        function onScroll() {
          if (pending) return;
          pending = true;
          requestAnimationFrame(update);
        }

        function onResize() {
          measure();
          onScroll();
        }

        measure();
        update();
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onResize);
      });
    }

    initArticle();
    document.addEventListener('shopify:section:load', initArticle);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details"] && !Shopify.designMode) return;
  try {
    
  /**
   * Drives both modes from one set of `<details>`.
   *
   * The panel height is the only thing that needs measuring — the toggle glyph
   * is a CSS transition in snippets/disclosure-toggle.liquid, and both run on
   * --details-duration so they land together. Same routine as sections/faq.liquid.
   */
  var DETAILS_QUERY = '(width < 1366px)';

  function detailsDuration(root) {
    var value = getComputedStyle(root).getPropertyValue('--details-duration').trim();
    if (value.slice(-2) === 'ms') return parseFloat(value);
    if (value.slice(-1) === 's') return parseFloat(value) * 1000;
    return 420;
  }

  function detailsReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* Measure before cancelling — a running animation *is* the current height. */
  function detailsStop(item, panel) {
    var height = panel.getBoundingClientRect().height;
    if (item.detailsAnimation) {
      item.detailsAnimation.cancel();
      item.detailsAnimation = null;
    }
    return height;
  }

  function detailsSlide(root, item, panel, from, to, onFinish) {
    /**
     * `fill: 'forwards'` holds the last frame, otherwise the height snaps back
     * to `auto` the instant the animation ends and flashes the panel for a
     * frame. The fill is dropped again once the element has settled.
     */
    var animation = panel.animate([{ height: from + 'px' }, { height: to + 'px' }], {
      duration: detailsDuration(root),
      easing: getComputedStyle(root).getPropertyValue('--details-ease').trim() || 'ease',
      fill: 'forwards',
    });

    item.detailsAnimation = animation;

    animation.onfinish = function () {
      if (onFinish) onFinish();
      animation.cancel();
      if (item.detailsAnimation === animation) item.detailsAnimation = null;
    };
  }

  function detailsOpen(root, item) {
    var panel = item.querySelector('[data-details-panel]');
    if (!panel) return;

    var from = item.open ? detailsStop(item, panel) : 0;

    item.removeAttribute('data-closing');
    item.open = true;
    detailsSyncTabs(root);

    if (detailsReducedMotion()) return;
    detailsSlide(root, item, panel, from, panel.scrollHeight);
  }

  function detailsClose(root, item) {
    var panel = item.querySelector('[data-details-panel]');
    if (!panel) return;

    var from = detailsStop(item, panel);
    item.setAttribute('data-closing', '');

    function settle() {
      item.open = false;
      item.removeAttribute('data-closing');
      detailsSyncTabs(root);
    }

    if (detailsReducedMotion()) {
      settle();
      return;
    }

    detailsSlide(root, item, panel, from, 0, settle);
  }

  function detailsCloseSiblings(root, current) {
    root.querySelectorAll('[data-details-item]').forEach(function (other) {
      if (other !== current && other.open) detailsClose(root, other);
    });
  }

  function detailsItems(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-details-item]'));
  }

  function detailsTabs(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-details-tab]'));
  }

  function detailsSyncTabs(root) {
    if (root.dataset.detailsMode !== 'tabs') return;

    detailsTabs(root).forEach(function (tab) {
      var panel = document.getElementById(tab.getAttribute('data-details-target'));
      var selected = !!(panel && panel.open && !panel.hasAttribute('data-closing'));

      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.setAttribute('tabindex', selected ? '0' : '-1');
    });
  }

  /**
   * Tab semantics are applied and *removed* by mode. Leaving `role="tab"` on a
   * hidden bar, or `role="tabpanel"` on a `<details>` whose `<summary>` is the
   * real control, is worse than no ARIA — the role would override the native
   * disclosure semantics and fight it.
   */
  function detailsApplyMode(root) {
    var accordion = window.matchMedia(DETAILS_QUERY).matches;
    var mode = accordion ? 'accordion' : 'tabs';

    if (root.dataset.detailsMode === mode) return;
    root.dataset.detailsMode = mode;

    var tabbar = root.querySelector('[data-details-tabbar]');
    var tabs = detailsTabs(root);
    var items = detailsItems(root);

    if (accordion) {
      if (tabbar) tabbar.removeAttribute('role');
      if (tabbar) tabbar.removeAttribute('aria-label');

      tabs.forEach(function (tab) {
        tab.removeAttribute('role');
        tab.removeAttribute('aria-controls');
        tab.removeAttribute('aria-selected');
        tab.removeAttribute('tabindex');
      });

      items.forEach(function (item) {
        item.removeAttribute('role');
        item.removeAttribute('aria-labelledby');
        item.removeAttribute('tabindex');
      });

      return;
    }

    if (tabbar) {
      tabbar.setAttribute('role', 'tablist');
      tabbar.setAttribute('aria-label', root.dataset.detailsLabel || '');
    }

    tabs.forEach(function (tab) {
      var panel = document.getElementById(tab.getAttribute('data-details-target'));

      tab.setAttribute('role', 'tab');
      if (panel) tab.setAttribute('aria-controls', panel.id);

      if (panel) {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.setAttribute('tabindex', '0');
      }
    });

    /* Tabs must always have exactly one panel showing. */
    var open = items.filter(function (item) {
      return item.open;
    });

    if (open.length === 0 && items.length) detailsOpen(root, items[0]);
    detailsSyncTabs(root);
  }

  function detailsActivate(root, tab) {
    var panel = document.getElementById(tab.getAttribute('data-details-target'));
    if (!panel) return;

    /* Clicking the active tab is a no-op: only the accordion may close all. */
    if (panel.open && !panel.hasAttribute('data-closing')) return;

    detailsCloseSiblings(root, panel);
    detailsOpen(root, panel);
  }

  function detailsBindTabs(root) {
    var tabs = detailsTabs(root);

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        detailsActivate(root, tab);
        tab.focus();
      });

      tab.addEventListener('keydown', function (event) {
        if (root.dataset.detailsMode !== 'tabs') return;

        var next = null;

        if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
        else if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
        else if (event.key === 'Home') next = tabs[0];
        else if (event.key === 'End') next = tabs[tabs.length - 1];
        else return;

        event.preventDefault();
        detailsActivate(root, next);
        next.focus();
      });
    });
  }

  function initProductDetails() {
    document.querySelectorAll('[data-details]').forEach(function (root) {
      if (root.dataset.detailsReady === 'true') return;
      root.dataset.detailsReady = 'true';

      detailsItems(root).forEach(function (item) {
        /**
         * A `name` group is closed synchronously by the browser, which leaves
         * nothing on screen to animate. With the script running, exclusivity
         * moves here so the outgoing panel collapses while the next expands.
         */
        item.removeAttribute('name');

        var summary = item.querySelector('summary');
        if (!summary) return;

        /* Enter and Space on a <summary> dispatch a click, so this covers both. */
        summary.addEventListener('click', function (event) {
          event.preventDefault();

          if (item.open && !item.hasAttribute('data-closing')) {
            detailsClose(root, item);
            return;
          }

          detailsCloseSiblings(root, item);
          detailsOpen(root, item);
        });
      });

      detailsBindTabs(root);
      detailsApplyMode(root);

      window.matchMedia(DETAILS_QUERY).addEventListener('change', function () {
        detailsApplyMode(root);
      });
    });
  }

  initProductDetails();
  document.addEventListener('shopify:section:load', initProductDetails);

  /**
   * The intercepted click would otherwise break selecting a block in the editor.
   * Selecting a row block opens the panel that owns it, which is why this
   * resolves the panel by climbing as well as descending.
   */
  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target;
    if (!block || !block.closest) return;

    var root = block.closest('[data-details]');
    if (!root) return;

    var item = block.querySelector('[data-details-item]') || block.closest('[data-details-item]');
    if (!item) return;

    detailsCloseSiblings(root, item);
    detailsOpen(root, item);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  function initProductSection() {
    var sections = document.querySelectorAll('.product');

    for (var i = 0; i < sections.length; i++) {
      var section = sections[i];

      if (section.dataset.productReady === 'true') continue;
      section.dataset.productReady = 'true';

      bindQuantitySteppers(section);
      bindVariantSelect(section);
    }
  }

  /**
   * The number input is the real control and works on its own; these buttons
   * only nudge it. `change` is dispatched alongside `input` so anything that
   * listens for either — now or later — sees the same value.
   */
  function bindQuantitySteppers(section) {
    var steppers = section.querySelectorAll('[data-quantity]');

    for (var i = 0; i < steppers.length; i++) {
      bindQuantityStepper(steppers[i]);
    }
  }

  function bindQuantityStepper(stepper) {
    var input = stepper.querySelector('[data-quantity-input]');
    var buttons = stepper.querySelectorAll('[data-quantity-step]');

    if (!input) return;

    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function (event) {
        var step = parseInt(event.currentTarget.getAttribute('data-quantity-step'), 10);
        var min = parseInt(input.getAttribute('min'), 10);
        var max = parseInt(input.getAttribute('max'), 10);
        var next = (parseInt(input.value, 10) || 0) + step;

        if (!isNaN(min) && next < min) next = min;
        if (!isNaN(max) && next > max) next = max;

        input.value = next;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  /**
   * Reloading on `?variant=` keeps the price, the availability and the buy
   * button rendered by Liquid, which is the whole reason this section needs no
   * client-side variant model. With scripting off the select still submits the
   * right variant; only the displayed price lags.
   */
  function bindVariantSelect(section) {
    var select = section.querySelector('[data-product-variants]');

    if (!select) return;

    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.location.href = url.toString();
    });
  }

  initProductSection();
  document.addEventListener('shopify:section:load', initProductSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  /**
   * The backdrop is markup the merchant may not have filled in and the carousel is markup a
   * one-quote section does not have, so the two are set up independently — otherwise a section
   * with a single testimonial would return before the background ever started.
   *
   * The video is left unfetched until the section is nearly on screen: it is decoration below the
   * fold, and nothing about the section needs it to load. Pausing on the way out keeps the decoder
   * idle while the reader is elsewhere on the page.
   */
  function initBackgroundVideo(root) {
    var slot = root.querySelector('[data-testimonials-video]');
    if (!slot) return;

    var template = slot.querySelector('[data-testimonials-video-template]');
    if (!template) return;

    // Matches the stylesheet, which hides the layer outright under reduced motion. Leaving the
    // template unopened also means the file is never fetched for those visitors.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var video = null;

    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            if (video) video.pause();
            return;
          }

          if (!video) {
            slot.appendChild(template.content.cloneNode(true));
            video = slot.querySelector('video');
            if (!video) return;
          }

          // A muted video may be started without a gesture, so this normally resolves; the
          // `autoplay` attribute covers it anyway and a browser that declines both simply leaves
          // the static lettering showing through.
          video.play().catch(function () {});
        });
      },
      { rootMargin: '200px' }
    ).observe(root);
  }

  function initTestimonials() {
    document.querySelectorAll('[data-testimonials]').forEach(function (root) {
      if (root.dataset.testimonialsReady === 'true') return;
      root.dataset.testimonialsReady = 'true';

      initBackgroundVideo(root);

      var track = root.querySelector('[data-testimonials-track]');
      var previous = root.querySelector('[data-action="testimonials-previous"]');
      var next = root.querySelector('[data-action="testimonials-next"]');
      if (!track || !previous || !next) return;

      var slides = Array.prototype.slice.call(track.querySelectorAll('[data-testimonials-slide]'));
      if (slides.length < 2) return;

      /**
       * The scroll position is the source of truth rather than a stored index,
       * so an arrow press after a swipe or a keyboard scroll continues from
       * whichever quote the reader actually landed on.
       */
      function currentIndex() {
        var closest = 0;
        var shortest = Infinity;

        slides.forEach(function (slide, index) {
          var distance = Math.abs(slide.offsetLeft - track.scrollLeft);
          if (distance < shortest) {
            shortest = distance;
            closest = index;
          }
        });

        return closest;
      }

      /**
       * Size the track to the quote(s) actually on screen. A flex row is
       * otherwise as tall as the longest slide, which is what opened the
       * extra gap under a short testimonial.
       */
      function syncTrackHeight() {
        var height = 0;
        var viewStart = track.scrollLeft;
        var viewEnd = viewStart + track.clientWidth;

        slides.forEach(function (slide) {
          var start = slide.offsetLeft;
          var end = start + slide.offsetWidth;
          if (start < viewEnd && end > viewStart) {
            height = Math.max(height, slide.offsetHeight);
          }
        });

        if (height > 0) track.style.height = height + 'px';
      }

      syncTrackHeight();
      track.classList.add('is-sized');
      track.addEventListener('scroll', syncTrackHeight);
      window.addEventListener('resize', syncTrackHeight);

      if (typeof ResizeObserver === 'function') {
        var slideResize = new ResizeObserver(syncTrackHeight);
        slides.forEach(function (slide) {
          slideResize.observe(slide);
        });
      }

      /**
       * Wrapping past either end keeps both arrows live: with a handful of
       * quotes a dead-ended arrow reads as broken rather than as "the end".
       */
      function go(step) {
        var index = (currentIndex() + step + slides.length) % slides.length;
        var motion = 'smooth';

        // An explicit `behavior` beats the stylesheet, so reduced motion has to
        // be honoured here too and not only in the media query below. It has to
        // be `instant` rather than `auto`, because `auto` defers right back to
        // the stylesheet this is overriding.
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          motion = 'instant';
        }

        track.scrollTo({ left: slides[index].offsetLeft, behavior: motion });
      }

      previous.addEventListener('click', function () {
        go(-1);
      });

      next.addEventListener('click', function () {
        go(1);
      });
    });
  }

  initTestimonials();
  document.addEventListener('shopify:section:load', initTestimonials);

  } catch(e) { console.error(e); }
})();
})();
